export default "__VITE_ASSET__04ea8b54__"